import { Dispatch } from 'redux';
import * as Action from './actions';

export function ClearAnalysisData() {
    return (dispatch: Dispatch<any>) => {
        dispatch(Action.clearAnalysisData.done({}));
    };
}